import useGeneralControlData from "../hooks/useGeneralControlData";
import ControlMenu from "../SettingControls/Controls"
import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../StateManagement/actions";
import TabLayoutWrapper from "./TabLayoutWrapper";

export default function SettingsContainer({ tabMenuText, configLevel }) {
  const settingFor = useSelector((state) => state.settings.settingFor);
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const defaultSetting = useSelector(state => state.settings.defaultSetting);


  let commonTabControls = [];
  let commonOverrideControlForAdminDocument = [];
  let commonLockControlForAdminDocument = [];
  let isOverride = 'false';
  let isLock = 'false';
  const common = useGeneralControlData();

  if (tabMenuText === "Advance") {
    commonTabControls = common.filter(s => (s.settingType === "EDisclosure" || s.settingType === "TrackKilledDocument" || s.settingType === "PasscodeLength" || s.settingType === "PasscodeExpiryPolicy"))
    commonTabControls = commonTabControls.filter(s => s.label !== undefined)
  } else if (tabMenuText === "DirectSendDefaults") {
    commonTabControls = common.filter(s => s.settingType !== "DefaultSettingsFor")
  } else if (tabMenuText === "Document") {
    commonLockControlForAdminDocument = common.filter(s => !s?.disableLockForAdminDocument)
    commonOverrideControlForAdminDocument = common.filter(s => !s?.disableOverrideForAdminDocument)
  } else if (tabMenuText === "DefaultDocumentSettings") {
    const isVotingSelected = common.some(s => s.settingType === "Voting" && s.value === "false");
    if (isVotingSelected) {
      commonTabControls = common.filter(s => s.settingType !== "ShareVotes")
    }
    if (commonTabControls.length === 0) {
      commonTabControls = common;
    }
    commonTabControls = commonTabControls.filter(s => !s?.disableOverrideLockControls);
  } else if (tabMenuText === "Storage") {
    commonTabControls = common.filter(s => s.settingType === "RPDLite");
  } else {
    commonTabControls = common.filter(s => !s?.disableOverrideLockControls && !s?.disableAdminLockedControls);
  }

  if (tabMenuText !== "Document") {
    isOverride = commonTabControls.filter((setting) => setting.Override === "true").length === commonTabControls.length ? "true" : "false"
    isLock = commonTabControls.filter((setting) => setting.Lock === "true").length === commonTabControls.length ? "true" : "false"
  }
  else {
    isOverride = commonOverrideControlForAdminDocument.filter((setting) => setting.Override === "true").length === commonOverrideControlForAdminDocument.length ? "true" : "false"
    isLock = commonLockControlForAdminDocument.filter((setting) => setting.Lock === "true").length === commonLockControlForAdminDocument.length ? "true" : "false"
  }






  let level = "common";
  if (tabMenuText === "ContentSecurity") {
    level = "commonContentSecuritySetting";
  }



  return (
    <>
      {(settingFor === "Company" || settingFor === "Admin") && defaultSetting === "Gateway" && (
        <ControlMenu
          containerClassname={`mb-3 row align-items-center mx-1 ${settingFor === "Company" ? "mt-comapny-11rm" : ""}`}
          settingType={"SelectAll"}
          companyLevel={settingFor === "Company" || settingFor === "Admin" ? true : false}
          selectAll={true}
          level={level}
          configLevel={configLevel}
          Override={isOverride}
          Lock={isLock}
          isStorageTab={tabMenuText === "Storage"}
        />
      )}
      {common.length > 0 && (
        <>
          {common.map((control, index) => {
            return (
              <ControlMenu
                key={index}
                {...control}
                companyLevel={settingFor === "Company" || settingFor === "Admin" ? true : false}
              />
            );
          })}
        </>
      )}
      {(tabMenuText === "DirectSendDefaults" ||
        tabMenuText === "ContentSecurity") && (
          <TabLayoutWrapper tabMenuText={tabMenuText} />
        )}
    </>
  );
}
